/* ── Country Selector Web Component ── */
(function () {
  'use strict';

  /* ── Cookie helpers ── */
  function setCookie(name, value, minutes) {
    const maxAge = minutes * 60;
    document.cookie = `${name}=${encodeURIComponent(value)};max-age=${maxAge};path=/;SameSite=Lax`;
  }

  function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [key, val] = cookie.trim().split('=');
      if (key === name) return decodeURIComponent(val);
    }
    return undefined;
  }

  class CountrySelectorComponent extends HTMLElement {
    async connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.closeBtn = this.querySelector('.country-selector-close');
      this.overlay = this.querySelector('.country-selector-overlay');
      this.cookieDuration = parseInt(this.dataset.cookieDuration || '10080', 10);

      this.bindEvents();

      const autoDetect = this.dataset.autoDetect !== 'false';
      if (autoDetect && !getCookie('country-selector-dismissed') && !this.isThemeEditor()) {
        await this.autoShow();
      }
    }

    isThemeEditor() {
      return window.Shopify?.designMode === true;
    }

    bindEvents() {
      this.closeBtn?.addEventListener('click', () => this.dismiss());

      this.overlay?.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.dismiss();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-visible')) {
          this.dismiss();
        }
      });
    }

    async autoShow() {
      try {
        const response = await fetch('/browsing_context_suggestions.json');
        const data = await response.json();
        const detectedCountry = data.detected_values.country.handle;
        const currentCountry = window.Shopify?.country || '';

        if (detectedCountry && currentCountry &&
            detectedCountry.toUpperCase() !== currentCountry.toUpperCase()) {
          this.highlightSuggested(detectedCountry);
          this.show();
        }
      } catch (e) {
        /* Silently fail — don't show modal if detection fails */
      }
    }

    highlightSuggested(countryCode) {
      const items = this.querySelectorAll('.country-selector-item[data-country-code]');
      let matched = false;
      let fallback = null;

      items.forEach((item) => {
        if (item.dataset.countryCode.toUpperCase() === 'EU') {
          fallback = item;
        } else if (item.dataset.countryCode.toUpperCase() === countryCode.toUpperCase()) {
          item.classList.add('is-suggested');
          matched = true;
        }
      });

      if (!matched && fallback) {
        fallback.classList.add('is-suggested');
      }
    }

    show() {
      this.classList.add('is-ready');
      void this.offsetWidth;
      requestAnimationFrame(() => {
        this.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      });
    }

    dismiss() {
      this.classList.remove('is-visible');
      document.body.style.overflow = '';
      setCookie('country-selector-dismissed', 'true', this.cookieDuration);
      setTimeout(() => {
        this.classList.remove('is-ready');
      }, 350);
    }

    open() {
      this.show();
    }
  }

  if (!customElements.get('country-selector-component')) {
    customElements.define('country-selector-component', CountrySelectorComponent);
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-country-selector-trigger]');
    if (!trigger) return;
    e.preventDefault();
    const selector = document.querySelector('country-selector-component');
    if (selector) selector.open();
  });
})();
